import React, { useRef, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import { createCPDInitialValues, findDurationType, findTypeOfCpd } from "../../../../data/cpdConstants";
import Pagination from "../../../../components/Pagination";
import { calculateWorkingDays, formatDateForDisplay } from "../../../../utils/helperFunctions";
import CreateCPDActivitiesForm from "../CreateCPDActivitiesForm";
import { CgClose } from "react-icons/cg";
import { getCPDById } from "../../../../redux/slices/atpSlice";

function Pending({ data, handlePagination, pageLimit, currentPage }) {
  const [isView, setIsView] = useState(false);
  const { current_page, total_pages } = useSelector((state) => state.atp.data);
  const [showModal, setShowModal] = useState(false);
  const [initialValues, setInitialValues] = useState(createCPDInitialValues);
  const dispatch = useDispatch();
  const [techFieldAdd, setTechFieldShow] = useState(false);

  const modalRef = useRef();
  const openModal = (detail = null) => {
    fetchByIdModal(detail?.id);
    setTechFieldShow(true);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const fetchByIdModal = (id) => {
    dispatch(getCPDById(id)).then((response) => {
      setInitialValues({
        ...response?.payload,
        date_time: response?.payload?.date_time ? moment(response?.payload?.date_time).format("DD/MM/YYYY HH:mm A") : null,
        files: response?.payload?.attachment?.length > 0 ? response?.payload?.attachment[0] : [],
        // techFieldAdd:techFieldAdd,
      });
    });
    setIsView(true);
  };
  return (
    <>
      {showModal && (
        <div className="Add_form manuallyform_popup">
          <div className={`modal custom-popup-overlay ${showModal ? "show" : ""}`}>
            <div className="modal-content custom-popup-add" ref={modalRef}>
              <div className="d-flex justify-content-between align-items-center">
                {" "}
                <h2>Add CPD Activity</h2>
                <div
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event propagation to parent
                    setIsView(false);
                    document.body.style.overflow = "auto";
                    setShowModal(false);
                  }}
                  className="d-flex justify-content-end croseicn"
                >
                  <CgClose
                    style={{
                      color: "#D1D5DB",
                      height: "30px",
                      width: "30px",
                    }}
                  />
                </div>
              </div>
              <div className="after-line-tittle"></div>
              <div>
                <CreateCPDActivitiesForm initialValues={initialValues} isView={isView} techFieldAdd={techFieldAdd} />
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        <div className="tabdiv accordion-body-cpd">
          <table className="table_layout">
            <thead>
              <tr className="">
                <th className="">No.</th>
                <th className="">Title</th>
                <th className="">Duration</th>
                <th className="">Category </th>
                <th className="">Date Added</th>
                <th className="">Location</th>
                {/* <th className="">Attachment</th> */}
                <th>Estimated Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <div className="bordertop"></div>
            {data?.length > 0 ? (
              <tbody className="">
                {data?.map((ele, index) => {
                  const date = calculateWorkingDays(ele?.updated_at, 60);
                  const workingDate = date.toLocaleDateString();
                  return (
                    <tr className="list-view-line-before" key={ele?.id}>
                      <td className="text-decoration-none text-black">{(currentPage - 1) * pageLimit + index + 1}</td>
                      <td className="text-decoration-none text-black text-uppercase">{ele?.title}</td>
                      <td>
                        {ele?.duration_time} {findDurationType(ele?.duration_type)}
                      </td>
                      <td>{findTypeOfCpd(ele?.type_of_cpd)}</td>
                      <td>{formatDateForDisplay(ele?.created_at)}</td>
                      <td>{ele?.location}</td>
                      {/* <td>{ele?.attachment_count} Attachment(s)</td> */}
                      <td>{(<>60 working days<br />({workingDate})</>)}</td>
                      <td>
                        <div
                          onClick={() => {
                            setIsView(true); // Set isView to true
                            openModal(ele); // Call openModal with view as true
                          }}
                          className="cursor-pointer"
                          style={{ color: "#29348f", textDecoration: "underline" }}
                        >
                          View
                        </div></td>
                    </tr>
                  )
                })}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={6} className="text-decoration-none text-center">
                    No Data Available
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
        <Pagination
          currentPage={current_page}
          totalPages={total_pages}
          setCurrentPage={handlePagination}
        />
      </div>
    </>
  );
}

export default Pending;
